let GoogleAnalytics = require('./google-analytics');
let ClickyAnalytics = require('./clicky-analytics');
let FacebookAnalytics = require('./facebook-analytics');

module.exports = {
  GoogleAnalytics,
  ClickyAnalytics,
  FacebookAnalytics
};
